import { motion } from "framer-motion";
import { Globe } from "lucide-react";
import { useLang } from "@/i18n";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export default function Worldwide() {
  const { t } = useLang();

  return (
    <section className="py-24 lg:py-32 border-y border-brand/10 bg-navy-800/30" data-testid="worldwide-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <motion.div {...reveal}>
          <p className="overline-label inline-flex items-center gap-2" data-testid="worldwide-overline">
            <Globe size={14} /> {t("world_over")}
          </p>
          <h2 className="mt-5 font-serif font-semibold text-4xl sm:text-5xl tracking-tight leading-tight" data-testid="worldwide-heading">
            {t("world_h1")} <span className="text-brand-300">{t("world_h2")}</span>
          </h2>
          <p className="mt-6 max-w-xl text-base text-cream/55 leading-relaxed" data-testid="worldwide-subcopy">
            {t("world_sub")}
          </p>
        </motion.div>

        <motion.div {...reveal} transition={{ ...reveal.transition, delay: 0.15 }} className="relative">
          <div className="absolute -inset-4 border border-brand/25 translate-x-5 translate-y-5" aria-hidden="true" />
          <div className="relative overflow-hidden" data-testid="worldwide-image-frame">
            <img
              src="/worldwide-service.webp"
              alt="Worldwide Service graphic — globe with connection lines emphasizing Canada, text: Wherever You Are, We Can Help"
              className="w-full h-auto"
              data-testid="worldwide-image"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
